export interface ILicenseHttpResponse {
  id: number;
  evideLicenseGuid: string | undefined;
  organisationName: string | undefined;
  evideLicenseName: string | undefined;
  licenseName: string | undefined; // TODO - remove once fixed by backend
  countryCode: string;
  contactFormId: number;
  registrationFormId: number;
  /** The licence's own logo for the top bar (public URL); null = Evide's. */
  logoUrl?: string | null;
}

export interface ILicenseSaveHttp {
  evideLicenseName: string;
  evideLicenceId: number,
  organisationName: string;
  countryCode: string,
  contactFormId: number,
  registrationFormId: number,
  includeAssessment: boolean
}

export interface EvideLicenseKeyInfo {
  evideLicenseId: number;
  licenseName: string;
  /** Organisation sign-in (SSO) is allowed on this licence. */
  organisationSignIn?: boolean;
  /** Its organisation sign-in email domains: a new user with one of these needs no password on the Users form. */
  organisationSignInDomains?: string[];
}

export interface ILicenseBasic {
  id: number;
  name: string;
}

export class License {
  constructor(
    public id: number,
    public licenseGuid?: string,
    public licenseName?: string,
    public organisationName?: string,
    public countryCode?: string,
    public contactFormId?: number,
    public registrationFormId?: number,
    public includeAssessment: boolean = true,
    public logoUrl: string | null = null
  ) { }

  public static adapt(data: ILicenseHttpResponse) {
    return new this(
      data.id,
      data.evideLicenseGuid,
      data.evideLicenseName || data.licenseName,
      data.organisationName,
      data.countryCode,
      data.contactFormId,
      data.registrationFormId,
      true,
      data.logoUrl ?? null
    );
  }

  public static crateBlank() {
    return new this(0, '', '', '', '', 0, 0);
  }

  public toSaveRequest(): ILicenseSaveHttp {
    return {
      evideLicenceId: this.id,
      evideLicenseName: this.licenseName,
      organisationName: this.organisationName,
      countryCode: this.countryCode,
      contactFormId: this.contactFormId,
      registrationFormId: this.registrationFormId,
      includeAssessment: this.includeAssessment
    }
  }
}
